import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  NgZone,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[isItemVisible]',
  standalone: false,
})
export class ItemVisibleDirective implements OnInit, OnDestroy {
  @Input() root: HTMLElement | null = null;

  @Input() rootMargin = '0px';

  @Input() threshold = 0;

  @Input() isContinuous = true;

  @Output() becameVisible = new EventEmitter<boolean>();

  private observer: IntersectionObserver | null = null;

  private isVisible = false;

  constructor(
    private readonly _elementRef: ElementRef,
    private readonly _ngZone: NgZone,
  ) {}

  ngOnInit() {
    this._ngZone.runOutsideAngular(() => {
      this.observer = new IntersectionObserver(
        entries => {
          const isVisible = entries[0].isIntersecting;

          if (!this.isContinuous) {
            if (this.observer) {
              this.observer.disconnect();
            }
          }

          // Only emit if visibility changed or this is the first/only observation
          if (isVisible !== this.isVisible || !this.isContinuous) {
            this.isVisible = isVisible;

            this._ngZone.run(() => {
              this.becameVisible.emit(isVisible);
            });
          }
        },
        {
          root: this.root,
          rootMargin: this.rootMargin,
          threshold: this.threshold,
        },
      );

      this.observer.observe(this._elementRef.nativeElement);
    });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
